module.exports = __webpack_public_path__ + "908e4d2e/img/copy-icon.408fdb2d.svg";